import { render, staticRenderFns } from "./quotationDesignCost-tab.vue?vue&type=template&id=7b741c42"
import script from "./quotationDesignCost-tab.vue?vue&type=script&lang=js"
export * from "./quotationDesignCost-tab.vue?vue&type=script&lang=js"
import style0 from "./quotationDesignCost-tab.vue?vue&type=style&index=0&id=7b741c42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports